import { isDesktopApp } from '../utils/environment';
import type { Cache as ICache } from './Cache';
import { BrowserCache } from './cache.web.browser';
import { DesktopCache } from './cache.web.desktop';

export const Cache: ICache = isDesktopApp ? DesktopCache : BrowserCache;
